import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './lng/eng/translation.json';
import zhTranslation from './lng/cn/translation.json';
import msTranslation from './lng/my/translation.json';
import hkTranslation from './lng/hk/translation.json';

const languageSelector = {
  en: {
    languages: 'Languages',
    lang_en: 'English',
    lang_zh: 'Simplified Chinese',
    lang_hk: 'Traditional Chinese (HK)',
    lang_ms: 'Bahasa Malaysia',
  },
  zh: {
    languages: '语言',
    lang_en: 'English',
    lang_zh: '中文 (简体)',
    lang_hk: '中文 (繁體)',
    lang_ms: 'Bahasa Malaysia',
  },
  ms: {
    languages: 'Bahasa',
    lang_en: 'English',
    lang_zh: 'Cina Ringkas',
    lang_hk: 'Cina Tradisional (HK)',
    lang_ms: 'Bahasa Melayu',
  },
  hk: {
    languages: '語言',
    lang_en: 'English',
    lang_zh: '中文 (簡體)',
    lang_hk: '中文 (繁體)',
    lang_ms: 'Bahasa Malaysia',
  },
};

const resources = {
  en: { translation: { ...enTranslation, ...languageSelector.en } },
  zh: { translation: { ...zhTranslation, ...languageSelector.zh } },
  ms: { translation: { ...msTranslation, ...languageSelector.ms } },
  hk: { translation: { ...hkTranslation, ...languageSelector.hk } },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'zh', 'ms', 'hk'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
